import React, { useState, useEffect } from "react";
import Header from "../components/header/Header";
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/footer/Footer";
import { Outlet } from "react-router-dom";

interface IProps {
  children: React.ReactNode;
}

const Layout: React.FC<IProps> = ({ children }) => {
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolling(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="flex flex-col">
      {/* Header */}
      <div className="sticky top-0 z-50 bg-white hover:opacity-100">
        <Header />
      </div>

      {/* Navbar */}
      <div
        className={`sticky top-[50px] z-40 transition-opacity duration-300  hover:opacity-100 ${
          scrolling ? "opacity-75" : "opacity-100"
        }`}
      >
        <Navbar />
      </div>

      <Outlet />

      {/* Main Content */}
      <main className="flex-grow">{children}</main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Layout;
